import Link from 'next/link';

/** The monogram from Assets/logo.svg, inlined so it can inherit currentColor. */
export function Monogram({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      className={className}
      aria-hidden="true"
      role="presentation"
    >
      <g
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
      >
        <path d="M28 34H72" />
        <path d="M50 34V86" />
        <path d="M50 58L78 86" />
        <path d="M50 58L74 38" />
      </g>
      <path
        d="M84 24C84 27.5 81.5 30 78 30C81.5 30 84 32.5 84 36C84 32.5 86.5 30 90 30C86.5 30 84 27.5 84 24Z"
        fill="#38BDF8"
      />
    </svg>
  );
}

/**
 * The brand as people search for it: "KIT Agency". The visible name and the
 * aria-label match the Organization name in the structured data, so a search
 * for the brand, the logo and the page all say the same thing.
 */
export function Wordmark({ href = '/', tone = 'ink' }: { href?: string; tone?: 'ink' | 'light' }) {
  const text = tone === 'light' ? 'text-white' : 'text-mist-100';
  return (
    <Link href={href} className="group inline-flex items-center gap-2.5" aria-label="KIT Agency home">
      <span className={`flex h-10 w-10 items-center justify-center rounded-xl bg-[#09090b] text-white transition-transform duration-300 group-hover:-rotate-6 ${tone === 'light' ? 'ring-1 ring-white/20' : ''}`}>
        <Monogram className="h-8 w-8" />
      </span>
      <span className={`whitespace-nowrap font-display text-[1.32rem] font-bold leading-none tracking-[-0.03em] ${text}`}>
        KIT <span className="text-spark-500">Agency</span>
      </span>
    </Link>
  );
}
